export enum Domains {
  MAVERICK = 'https://register.prospected.ai',
  IGNITE = 'https://register.ignitecommerce.io',
}

export enum BrandsHub {
  MaverickX = 'mavx',
  Ignite = 'ignite',
}
